import script from "./TileDashboard.vue?vue&type=script&setup=true&lang=ts"
export * from "./TileDashboard.vue?vue&type=script&setup=true&lang=ts"

import "./TileDashboard.vue?vue&type=style&index=0&id=9283944a&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9283944a"]])

export default __exports__